import React, { useState } from "react";
import Select from "react-select";
import { FaPlus, FaTrash, FaCheck, FaTimes } from "react-icons/fa";
import { QUESTION_TYPES } from "../_constant";

export const DependentQuestionForm = ({
  onSave,
  onCancel,
  question = {},
  isEditing = false,
  parentQuestionName = "",
}) => {
  const [text, setText] = useState(question.text || "");
  const [type, setType] = useState(question.type || "text");
  const [isRequired, setIsRequired] = useState(question.is_required || false);
  const [options, setOptions] = useState(question.options || []);

  const questionTypeOptions = QUESTION_TYPES.map((opt) => ({
    value: opt.value,
    label: opt.label,
  }));

  const handleSave = () => {
    if (!text.trim()) {
      alert("The question text field is required.");
      return;
    }
    if (
      (type === "dropdown" ||
        type === "checkbox_group" ||
        type === "dropdown_search") &&
      options.length === 0
    ) {
      alert(
        "Please provide at least one option for this question type before saving."
      );
      return;
    }
    onSave({ ...question, text, type, is_required: isRequired, options });
  };

  const addOption = () => {
    setOptions((prev) => [...prev, { label: "", dependent_questions: [] }]);
  };

  const updateOption = (index, value) => {
    const updatedOptions = [...options];
    updatedOptions[index].label = value;
    setOptions(updatedOptions);
  };

  const deleteOption = (index) => {
    setOptions((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="p-6 border rounded shadow bg-gray-50">
      <h3 className="text-xl font-bold mb-4 text-blue-600">
        {isEditing ? "Edit Dependent Question" : "Add Dependent Question"}
      </h3>
      {parentQuestionName && (
        <div className="mb-4 p-3 bg-blue-100 border-l-4 border-blue-500 rounded">
          <p className="text-sm text-blue-800 font-semibold">
            Creating a dependent question for:
          </p>
          <p className="text-blue-900 font-bold">{parentQuestionName}</p>
        </div>
      )}
      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-1">
          Question Text
        </label>
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="border p-3 w-full rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Enter the question text"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-1">
          Question Type
        </label>
        <Select
          value={questionTypeOptions.find((opt) => opt.value === type)}
          onChange={(selected) => setType(selected.value)}
          options={questionTypeOptions}
          className="basic-single"
          classNamePrefix="select"
        />
      </div>
      {(type === "dropdown" ||
        type === "checkbox_group" ||
        type === "dropdown_search") && (
        <div className="mb-4">
          <label className="block text-gray-700 font-semibold mb-2">
            Options
          </label>
          {options.map((option, index) => (
            <div key={index} className="flex items-center gap-2 mb-2">
              <input
                type="text"
                value={option.label}
                onChange={(e) => updateOption(index, e.target.value)}
                className="border p-3 flex-grow rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder={`Option ${index + 1}`}
              />
              <button
                onClick={() => deleteOption(index)}
                className="bg-red-500 text-white p-2 rounded hover:bg-red-600"
                title="Delete Option"
              >
                <FaTrash />
              </button>
            </div>
          ))}
          <button
            onClick={addOption}
            className="bg-green-500 text-white px-4 py-2 rounded shadow hover:bg-green-600 flex items-center gap-2"
          >
            <FaPlus /> Add Option
          </button>
        </div>
      )}
      <div className="mb-4 flex items-center gap-2">
        <input
          type="checkbox"
          checked={isRequired}
          onChange={(e) => setIsRequired(e.target.checked)}
          className="mr-2"
        />
        <span className="text-gray-700">Mark this question as required</span>
      </div>
      <div className="flex justify-end gap-3 mt-4">
        <button
          onClick={onCancel}
          className="bg-gray-400 text-white px-4 py-2 rounded shadow hover:bg-gray-500 flex items-center gap-2"
        >
          <FaTimes /> Cancel
        </button>
        <button
          onClick={handleSave}
          className="bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-600 flex items-center gap-2"
        >
          <FaCheck /> Save
        </button>
      </div>
    </div>
  );
};
